/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { TicketWithoutSerialNumberUpdateDto } from '../../models/ticket-without-serial-number-update-dto';

export interface TicketControllerUpdateTicketWithouSerialNumber$Params {
  id: number;
      body: TicketWithoutSerialNumberUpdateDto
}

export function ticketControllerUpdateTicketWithouSerialNumber(http: HttpClient, rootUrl: string, params: TicketControllerUpdateTicketWithouSerialNumber$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: BaseResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, ticketControllerUpdateTicketWithouSerialNumber.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: BaseResponse;
      }>;
    })
  );
}

ticketControllerUpdateTicketWithouSerialNumber.PATH = '/ticket/update-ticket-without-serial/{id}';
